import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { useTranslate } from 'react-admin'
import { useMemo } from 'react'

export const WrapperDashboard = ({ index, setList, item, id }) => {
  const translate = useTranslate()

  const application = useMemo(() => (
    item.allApplicationToFilter?.find(elem => elem.application_id === item.applications?.checkedApplication)
  ), [item])

  const dashboardsOptions = useMemo(() => ([
    'SELLER',
    'OPERATIONS',
    ...(application?.config?.dashboard?.options ?? [])
  ]), application)

  const onDashboardChange = (e) => {
    const newVal = e.target.value
    const setAndRestoreItem = (item) => {
      return {
        ...item,
        dashboard: newVal,
      }
    }
    setList((prev) => prev.map((item) => (item.id === id ? setAndRestoreItem(item) : item)))
  }

  return (
    <SelectInput
      source={`aplications[${index}].dashboard`}
      optionsText={['name']}
      optionValue='id'
      sx={{ width: 300 }}
      onChange={onDashboardChange}
      options={dashboardsOptions.map(elem => ({
        id: elem, name: translate(`ra.field.${elem.toLowerCase()}`)
      }))}
      label={null}
    />
  )
}
